<template lang="pug">
  .modal.is-active(key="modal-editar")
    .modal-background(@click="closeModalAdd()")
    .card
      header.modal-card-head.display-flex
        p.flex-1
          span(v-if="sala && sala.id") Editar sala
          span(v-else) Crear sala
        span.icon.close.pointer(
            @click="$emit('close')"
          )
            i.fa.fa-close
      .card-content
        .title
          .display-flex
            .control.margin-bottom-10.text-center
              p.margin-bottom-5 Activo
              input.checkbox(
                type="checkbox",
                v-model="activo"
                :disabled="isSaving"
              )
          .control.margin-bottom-10
            p.margin-bottom-5 Sala
            input.input.w-300(
              type="text",
              v-model="titulo"
              :disabled="isSaving"
            )
          .control.margin-bottom-10
            p.margin-bottom-5 Descripción
            textarea.textarea.w-300(
              style="field-sizing: content !important;",
              v-model="descripcion"
              :disabled="isSaving"
            )
      footer.card-footer
        a.card-footer-item.is-success(@click="guardar")
          span(v-if="isSaving") Guardando...
          span(v-else) Guardar
        a.card-footer-item( @click="$emit('close')")
          strong Cancelar

</template>

<script>
import { apiPost, apiPut, notify } from '../util/general'

export default {
  name: 'sala_editar',
  props: ['sala'],
  data () {
    return {
      isSaving             : false,
      titulo               : '',
      descripcion          : '',
      id: '',
      activo               : 1
    }
  },
  mounted () {
    var vm = this
    if (vm.sala) {
      vm.titulo = vm.sala.titulo
      vm.id = +vm.sala.id
      vm.descripcion = vm.sala.descripcion
      vm.activo = vm.sala.activo
    }
  },
  methods: {
    guardar () {
      var vm = this
      // validacion titulo
      if (!vm.titulo) return notify(vm, 'error', 'Error', 'Escriba un título.')
      if (vm.isSaving) return;
      vm.isSaving = true
      var obj = {
        idSala: vm.id,
        titulo: vm.titulo,
        descripcion: vm.descripcion,
        activo: vm.activo
      }
      Promise.resolve()
      .then(() => {
        if (vm.id) {
          return vm.actualizar(vm, obj)
        } else {
          return vm.insertar(vm, obj)
        }
      })
      .then((data) => {
        notify(vm, 'success', 'Éxito', data.message)
        vm.$emit('closeRefresh')
      })
      .catch((error) => {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    insertar (vm, obj) {
      return new Promise((resolve, reject) => {
        apiPost(vm, '/reunion/sala/gestion', obj, function (data) {
          resolve(data)
        }, function (error) {
          reject(error)
        }, function () {
          vm.isSaving = false
        })
      })
    },
    actualizar (vm, obj) {
      return new Promise((resolve, reject) => {
        apiPut(vm, '/reunion/sala/gestion', obj, function (data) {
          resolve(data)
        }, function (error) {
          reject(error)
        }, function () {
          vm.isSaving = false
        })
      })
    },
    closeModalAdd () {
      this.$emit('close')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .input-container
    display flex
    align-items center
    .input
      flex 1
      width 100px
    .erase-data
      cursor pointer
      margin-left 5px
  .pointer
    cursor pointer
  .solicitud-vacaciones
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase
      .little
        font-size 14px

  .contenedor-datos
    display flex
    justify-content center
    >*
      transition: all 0.5s;

    .contenedor-transaccion
      .fechas
        display flex
        justify-content center
        .control
          padding 10px

      .acciones
        display flex
        margin-top 10px
        .button
          flex 1
          margin 5px

  .indicaciones
    flex 1
    padding 10px
    border 1px solid #209cee
    color: #12537e;
    background-color #f6fbfe
    display flex
    flex-direction column
    margin 10px
    max-width: 426px;

    strong
      color #209cee

    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 21px
      margin-bottom 5px

    .list
      display flex
      flex-direction column
      justify-content center
      flex 1
      text-align left
      .list-item
        padding-left 10px

  .codigo-empleado
    position relative
    .control
      text-align center
      .input
        width 100px

  .pop-over
      background: #fff;
      border-radius: 3px;
      border: 1px solid #d6dadc;
      border-bottom-color: #c4c9cc;
      -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
      box-shadow: 0 1px 6px rgba(0,0,0,.15);
      position: absolute;
      width: 300px;
      z-index: 70;
      top 0
      left: 42px;
</style>



// WEBPACK FOOTER //
// c_gestion_salas_reuniones_editar.vue?eb491384